import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/components/LandingPageInteractive.tsx");
